// @ts-nocheck
import React, { Suspense, useEffect, useState, startTransition } from 'react';
import { useUser, useAuth, useOrganization, useOrganizationList, OrganizationSwitcher } from '@/auth/clerkShim';
import { useNavigate, redirect, useSearchParams } from 'react-router-dom';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import LoadingDots from "@/components/icons/loading-dots";
import adminStore from '@store/adminStore';

import _ from 'lodash';


function SetupPageNew() {
  const { user, isSignedIn } = useUser();
  const { organization, isLoaded } = useOrganization();
  const { setActive } = useOrganizationList();
  const [searchParams] = useSearchParams();
  const [memberships, setMemberships] = useState([]);
  const navigate = useNavigate();
  const auth = useAuth();
  const params = searchParams.toString();

  if (!isSignedIn) {
    return <div>Loading...</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  if (organization) {
    startTransition(() => {
      navigate('/admin/organize');
    });
  }

  useEffect(() => {
    async_getOrganizationMemberships();
  }, []);

  const async_getOrganizationMemberships = async () => {
    const memberships = await user.getOrganizationMemberships();
    if (memberships.length > 0) {
      if (memberships.length === 1) {
        setActive({ organization: memberships[0].organization.id });
      }
      setMemberships(memberships);
    } else {
      startTransition(() => {
        navigate('/create/select-contest');
      });
    }
  }

  const onOrganizationChange = (value) => {
    setActive({ organization: value });
  }

  return (
    <div className="relative">
      <Select onValueChange={onOrganizationChange} value={auth.orgId}>
        <SelectTrigger>
          <SelectValue placeholder="Select an organization" />
        </SelectTrigger>
        <SelectContent>
          {memberships.map((membership) => (
            <SelectItem key={membership.organization.id} value={membership.organization.id}>{membership.organization.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <OrganizationSwitcher />
    </div>
  );
}

export default SetupPageNew;
